/** Cores dos gráficos das estatísticas (mesma família dos destaques dos módulos). */
const palette = {
  blue: '#5A80FB',
  blueSoft: '#B9CAFE',
  pink: '#ED3680',
  green: '#2E9E5B',
  greenSoft: '#A8DDBD',
  amber: '#E08A00',
  red: '#D1344B',
  purple: '#7C3AED',
  teal: '#0F9D8A',
  gray: '#A0AEC0',
  grid: '#F0F3F9',
  text: '#718096',
};

/** Cor de uma nota de satisfação (0 a 10): verde promotor, âmbar neutro, vermelho detrator. */
export const scoreColor = (score) => (score >= 9 ? palette.green : score >= 7 ? palette.amber : palette.red);

/** Sequência para rankings e roscas com muitos itens. */
export const SERIES_COLORS = [palette.blue, palette.pink, palette.teal, palette.amber, palette.purple, palette.green, palette.gray];

export default palette;
